import {useState} from "react";
import {ICoordinates} from "../types";

const useCoordinates = () => {
  const [coordinates, setCoordinates] = useState<ICoordinates[]>([]);

  const updateCoordinates = (
    id: number | string,
    xStart: number,
    yStart: number,
    xEnd: number,
    yEnd: number
  ) => {
    setCoordinates((prevCoordinates) => {
      const existingCoord = prevCoordinates.find((coord) => coord.id === id);
      if (existingCoord) {
        return prevCoordinates.map((coord) =>
          coord.id === id ? {...coord, xStart, yStart, xEnd, yEnd} : coord
        );
      } else {
        return [...prevCoordinates, {id, xStart, yStart, xEnd, yEnd}];
      }
    });
  };

  const resetCoordinates = () => {
    setCoordinates([]);
  };

  return {coordinates, updateCoordinates, resetCoordinates};
};

export default useCoordinates;
